/* eslint-disable no-unused-vars */
import * as Yup from 'yup'

export const schemaPickingProductValidation = Yup.object({
  sku: Yup.string()
    .min(3, 'Debe ingresar a lo menos 3 caracteres')
    .max(50, 'El campo acepta como máximo 50 caracteres.')
    .required('Campo obligatorio.')
})

export const EnumPickingValidate = [
  {
    id: 1,
    name: 'OK',
    color: '#4caf50',
    btnName: 'btnCompleto',
    textColor: 'white'
  },
  {
    id: 2,
    name: 'COMPLETO',
    color: '#4caf50',
    btnName: 'btnCompleto',
    textColor: 'white'
  },
  {
    id: 3,
    name: 'CON QUIEBRE',
    color: '#f48fb1',
    btnName: 'btnDiferencia',
    textColor: 'black'
  },
  {
    id: 4,
    name: 'DIFERENCIA',
    color: '#f48fb1',
    btnName: 'btnDiferencia',
    textColor: 'black'
  }
]
